const Styles = {
  mainContainer: {
    display: "flex",
    padding: "16px 10px",
    alignItems: "center",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "6px",
    background: "#fff",
    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.1)",
    marginTop: "10px",
  },
};
export default Styles;
